import {createSlice} from "@reduxjs/toolkit";

const initialBusinessesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  businessForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const businessesSlice = createSlice({
  name: "businesses",
  initialState: initialBusinessesState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getbusinessById
    businessFetched: (state, action) => {
      state.actionsLoading = false;
      state.businessForEdit = action.payload.businessForEdit;
      state.error = null;
    },
    // findbusinesses
    businessesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
	  state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createbusiness
    businessCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.business);
    },
    // updatebusiness
    businessUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.business.id) {
          return action.payload.business;
        }
        return entity;
      });
    },
    // deletebusiness
    businessDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deletebusinesses
    businessesDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // businessesUpdateState
    businessesStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      let normalizedStatus = status;
      if (status === 0 || status === '0') normalizedStatus = 'approved';
      else if (status === 1 || status === '1') normalizedStatus = 'pending';
      else if (status === 2 || status === '2') normalizedStatus = 'rejected';
      else if (status === 4 || status === '4') normalizedStatus = 'moreinfo';
      else if (status === 5 || status === '5') normalizedStatus = 'draft';
      state.entities = (state.entities || []).map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = normalizedStatus;
        }
        return entity;
      });
    }
  }
});
